/**
 * @file mapper.ts
 *
 * @fileoverview Provides mapping utils functions.
 */

/**
 * Concatenates array items with given concatenator string.
 *
 * @param {Array<any> | null} array
 *  Array with values to be mapped.
 * @param {string} fieldName
 *  Field name whose value will be used for mapping.
 * @param {string} concatenator
 *  Concatenator string.
 * @returns {string}
 *  String with array's items fieldName values joined with concatenator.
 */
export const concatArrayItems = (
  array: Array<any> | null = [],
  fieldName: string,
  concatenator: string = ' | ',
): string | null =>
  array?.map((item) => item[fieldName]).join(concatenator) ?? null;
